import r from "./generateUtilityClasses.mjs";
import e from "./generateUtilityClass.mjs";
function a(t) {
  return e("MuiPickersLayout", t);
}
const i = r("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "shortcuts"]);
export {
  a as getPickersLayoutUtilityClass,
  i as pickersLayoutClasses
};
//# sourceMappingURL=pickersLayoutClasses.mjs.map
